export const ROOT = '/OnboardingTrainingTrackerAPI';
export const LIST = `${ROOT}/getonboardingtrainingpage`;
export const TRAINING_LIST = `${ROOT}/getonboardingparticipanttrainingspage`;
export const EXPORT = `${ROOT}/export`;
export const EXPORT_EMPLOYEE_DETAILS = `${ROOT}/exportemployeedetail`;
